import { CONTEXT_NAMES } from '@adsk/alloy-helpers';
import { ProductIdType, ToolIdType } from '@adsk/alloy-provider';
import {
  getOrCreateGlobalContext,
  useStoreWithValidation,
} from '@adsk/alloy-react-context';

type CurrentProductIdContextType = {
  productId?: ProductIdType;
};

type CurrentToolIdContextType = {
  toolId?: ToolIdType;
};

const CurrentProductIdContext =
  getOrCreateGlobalContext<CurrentProductIdContextType>(
    CONTEXT_NAMES.CurrentProductIdContext,
  );

const CurrentToolIdContext = getOrCreateGlobalContext<CurrentToolIdContextType>(
  CONTEXT_NAMES.CurrentToolIdContext,
);

export const useUnsafeCurrentProductId = () => {
  const currentProductIdContext =
    useStoreWithValidation<CurrentProductIdContextType>(
      CONTEXT_NAMES.CurrentProductIdContext,
      {
        hook: 'useCurrentProductIdContext',
        provider: 'CurrentProductIdProvider',
        context: CurrentProductIdContext,
        shouldThrowError: false,
      },
    );
  return currentProductIdContext?.productId;
};

export const useUnsafeCurrentToolId = () => {
  const currentToolIdContext = useStoreWithValidation<CurrentToolIdContextType>(
    CONTEXT_NAMES.CurrentToolIdContext,
    {
      hook: 'useCurrentToolIdContext',
      provider: 'CurrentToolIdProvider',
      context: CurrentToolIdContext,
      shouldThrowError: false,
    },
  );
  return currentToolIdContext?.toolId;
};
